import React, { useEffect, useState } from 'react'
import style from "./claim.module.css"
// import Footer from '../../Footer'
// import { NewFooter } from '../../NewFooter'

import {
    TOKEN_CLAIM
  } from "../../../Config/index";

import Tokenclaim_ABI from "../../../Config/Tokenclaim.json";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";

import { Link } from 'react-router-dom'
import { Modal } from './Modal'
import { ConnectButton, useConnectModal } from '@rainbow-me/rainbowkit'
import { useAccount, useBalance, useContractRead } from "wagmi";
import {  ethers } from "ethers";
import convertWeiToEther from '../../../Utils/convertWeiToEther';
import useCustomContractWrite from '../../../Hooks/useCustomContractWrite';
import { NewFooter } from '../../NewFooter';
 



export const Claim = () => {
    const [isOpen, setOpen] = useState(false)
    const { openConnectModal } = useConnectModal();
    const { address, isConnected } = useAccount();
    

    const [timeLeft, setTimeLeft] = useState({days:0, hours:0, min:0, sec:0})


    const { data: userinfo  } = useCustomContractRead({
        Adrress: TOKEN_CLAIM,
        Abi: Tokenclaim_ABI,
        FuncName: "userInfo",
        Args: [address],
        isEnabled: address !== undefined,
      });
    
    const {
        executeWrite: claimContractWrite,
        isLoading: isLoadingClaim,
        isSuccess: isSuccessClaim,
        isError: isErrorClaim,
        error: errorClaim,
        txHash: claimContractWaitForTransaction
      } = useCustomContractWrite({
        address: TOKEN_CLAIM,
        abi: Tokenclaim_ABI,
        functionName: "claim",
        isEnabled:
          parseFloat?.(userinfo === "" ? "0" : userinfo) > 0
      });
    
    const calculateTimeLeft = () => {
        const difference = new Date("02/04/2025") - new Date();
        if (difference <= 0) {
            return { days: 0, hours: 0, min: 0, sec: 0 }
        }
        return {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            min: Math.floor((difference / 1000 / 60) % 60),
            sec: Math.floor((difference / 1000) % 60)
        }
    } 

    useEffect(() => {
        document.querySelector(".nav_container").style.display = "none"
        const timer = setInterval(()=>{
            setTimeLeft(calculateTimeLeft())
        },1000)

        return ()=> clearInterval(timer)
    }, [])
    return (
        <main className={style.claim_cont}>
            <div className={style.content}>
                <div className='d-flex justify-content-between py-3 sm:py-5 container position-relative' style={{ zIndex: "2" }}>
                    <Link to="/" className={style.logo + ' text-decoration-none d-flex gap-2 align-items-center'}>
                        <img src="/icons/logo.svg" alt="" />
                        <span>SHiLD</span>
                    </Link>
                    {!isConnected ? <button className='btn1 px-2' onClick={openConnectModal}>Connect Wallet</button>
                        : <ConnectButton />}

                </div>
                <div className='container d-flex flex-column flex-lg-row justify-content-between align-items-center gap-4 py-5 position-relative' style={{ zIndex: "2" }}>
                    <div className={style.left}>
                        <p>We’re Proudly</p>
                        <h1>Launching in
                            {/* <span> 31st Jan</span> */}
                            </h1>
                        <div className={style.countDown + ' d-flex gap-2 mt-3'}>
                            <div>
                                <p className='mb-0 text-center'>{timeLeft.days<10?"0"+timeLeft.days:timeLeft.days}</p>
                                <p className='text-center mb-0'>Days</p>
                            </div>
                            <div>
                                <p className='mb-0 text-center'>{timeLeft.hours<10?"0"+timeLeft.hours:timeLeft.hours}</p>
                                <p className='text-center mb-0'>Hours</p>
                            </div>
                            <div>
                                <p className='mb-0 text-center'>{timeLeft.min<10?"0"+timeLeft.min:timeLeft.min}</p>
                                <p className='text-center mb-0'>Minuts</p>
                            </div>
                            <div>
                                <p className='mb-0 text-center'>{timeLeft.sec<10?"0"+timeLeft.sec:timeLeft.sec}</p>
                                <p className='text-center mb-0'>Seconds</p>
                            </div>
                        </div>
                        <p className='fs-4 mt-5'>Claim your Rewards now</p>
                    </div>
                    <div className={style.right + " p-3"}>
                        <h3 className='text-center'>Claim Rewards</h3>
                        {!isConnected ? <div className={style.unconnect + " d-flex justify-content-center align-items-center px-3"}>
                            <p className='text-center fw-semibold'>Connect your Wallet to see Rewards Available</p>
                        </div> :
                            <div className={style.connected + " d-flex flex-column justify-content-center align-items-center"}>
                                <span>{userinfo ? convertWeiToEther(userinfo) : '0'}</span>
                                <p className='text-center fw-semibold'>Available to Claim</p>
                            </div>}
                        {!isConnected ? <button className='btn1 w-100 py-3 mt-3' onClick={openConnectModal}>Connect Wallet</button>
                            : <button className='btn1 w-100 py-3 mt-3' onClick={async () => {
                                try {
                                  await claimContractWrite();
                                } catch (error) {
                                  //console.log(error);
                                }
                              }}>Claim Now</button>}
                    </div>
                </div>
            </div>
            <NewFooter />
            {isOpen && <Modal setOpen={setOpen} />}
        </main>
    )
}
